import { DiscountModels } from '@getgreenline/products'
import {
  CreateChildProduct,
  CreateProduct,
} from '../containers/Dashboard/DashboardProducts/AddProduct/ProductStore'
import { CurrentCompanyStore } from '../stores/CurrentCompanyStore'

export const availableDiscounts = (
  currentCompanyStore: CurrentCompanyStore,
  product: CreateProduct | CreateChildProduct,
) => {
  const discounts = currentCompanyStore.productStore?.discounts || []

  return discounts.filter((discount) => {
    // Products
    const excludeProductIds = discount.products.filter((p) => p.type === 'exclude').map((p) => p.id)
    const includeProductIds = discount.products.filter((p) => p.type === 'include').map((p) => p.id)

    if (excludeProductIds.length > 0) {
      if (excludeProductIds.includes(product.id || '')) {
        return false
      }
    }
    if (includeProductIds.length > 0) {
      if (!includeProductIds.includes(product.id || '')) {
        return false
      }
    }

    // Categories
    const excludeCategoryIds: string[] = []
    const discountExcludeCategoryIds = discount.categories
      .filter((p) => p.type === 'exclude')
      .map((p) => p.id)
    discountExcludeCategoryIds.forEach((c) => {
      currentCompanyStore?.productStore?.flattenedCategories.forEach((fc) => {
        if (fc.id === c) {
          excludeCategoryIds.push(fc.id)
        } else if (fc.parentCategoryId === c) {
          excludeCategoryIds.push(fc.id)
        }
      })
    })
    const includeCategoryIds: string[] = []
    const discountIncludeCategoryIds = discount.categories
      .filter((p) => p.type === 'include')
      .map((p) => p.id)
    discountIncludeCategoryIds.forEach((c) => {
      currentCompanyStore?.productStore?.flattenedCategories.forEach((fc) => {
        if (fc.id === c) {
          includeCategoryIds.push(fc.id)
        } else if (fc.parentCategoryId === c) {
          includeCategoryIds.push(fc.id)
        }
      })
    })

    if (excludeCategoryIds.length > 0 && product.categoryId) {
      if (excludeCategoryIds.includes(product.categoryId)) {
        return false
      }
    }

    if (includeCategoryIds.length > 0) {
      if (!product.categoryId && !includeProductIds.includes(product.id || '')) {
        return false
      }

      if (product.categoryId && !includeCategoryIds.includes(product.categoryId)) {
        return false
      }
    }

    return true
  })
}

export const getAvailableSalesChannels = () => {
  return Object.values(DiscountModels.SalesChannels).filter((salesChannel) => salesChannel.id > 0)
}

export type DiscountsPermissions = {
  canUseExternalLoyalty: boolean
  canAccessLoyalty: boolean
}
